// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-users-modal[data-v-e8e0e1d8]{border-radius:15px}[data-v-e8e0e1d8] .v-input__slot{align-items:start}[data-v-e8e0e1d8] .v-input--checkbox .v-label{margin-top:3px}", ""]);
// Exports
module.exports = exports;
